import React from 'react';
import Svg, { Mask, Path, Rect, ClipPath, G, Defs } from 'react-native-svg';

export function VideoFilled({ width, height }) {
  return (
    <>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          d="M18.834 2.75H4.16732C3.1548 2.75 2.33398 3.57081 2.33398 4.58333V13.75C2.33398 14.7625 3.1548 15.5833 4.16732 15.5833H18.834C19.8465 15.5833 20.6673 14.7625 20.6673 13.75V4.58333C20.6673 3.57081 19.8465 2.75 18.834 2.75Z"
          fill="#368665"
          stroke="#368665"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M11.5 15.583V19.2497"
          stroke="#368665"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M7.83398 19.25H15.1673"
          stroke="#368665"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M9.66602 6.41699L14.2493 9.16699L9.66602 11.917V6.41699Z"
          fill="white"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </Svg>
    </>
  );
}
